export var EOrderBookType;
(function (EOrderBookType) {
    EOrderBookType["EQ"] = "OrderEquity";
    EOrderBookType["OEQ"] = "OpenOrderEquity";
    EOrderBookType["CEQ"] = "CloseOrderEquity";
    EOrderBookType["MF"] = "OrderMutualFunds";
    EOrderBookType["MFH"] = "OrderMutualFundsHoldings";
    EOrderBookType["OMFH"] = "OpenOrderMutualFundsHoldings";
    EOrderBookType["CMFH"] = "CloseOrderMutualFundsHoldings";
    EOrderBookType["NFO"] = "OrderNewFundOrder";
    EOrderBookType["FUT"] = "futures";
    EOrderBookType["OPT"] = "options";
    EOrderBookType["ETF"] = "ETF";
    EOrderBookType["NCD"] = "NCD";
    EOrderBookType["EQSIP"] = "EQSIP";
    EOrderBookType["MFSIP"] = "MFSIP";
    EOrderBookType["CO"] = "OrderCommodity";
    EOrderBookType["OCO"] = "OpenOrderCommodity";
    EOrderBookType["CCO"] = "CloseOrderCommodity";
    EOrderBookType["MFSIPC"] = "MFSIPChild";
    EOrderBookType["IPO"] = "IPO";
    EOrderBookType["NCDIPO"] = "NCDIPO";
    EOrderBookType["OFS"] = "OFS";
})(EOrderBookType || (EOrderBookType = {}));
